module.exports = __webpack_public_path__ + "img/11.7758cc9a.jpg";